const KEY = 'kelimoConnectionTraceV142';
const LIMIT = 160;

export function recordConnectionEvent(event, details = {}) {
  try {
    const previous = JSON.parse(localStorage.getItem(KEY) || '[]');
    const entries = Array.isArray(previous) ? previous : [];
    entries.push({ at: new Date().toISOString(), event, clientVersion: 'v225', ...details });
    localStorage.setItem(KEY, JSON.stringify(entries.slice(-LIMIT)));
  } catch (_) {
    // Diagnostics must never interrupt the game (private mode/quota included).
  }
}

export function getConnectionTrace() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch (_) { return []; }
}
